/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Select } from '@atoms';
import { NARROW_COL } from '@constants';

import Form from '../Form';

import { MODULE_LAYOUTS } from './constants';

const LayoutField = (props) => (
  <Form.Item wrapperCol={NARROW_COL} {...props}>
    <Select placeholder="- Choose an module layout -">
      {MODULE_LAYOUTS.map(({ key, label }) => (
        <Select.Option key={key} value={key}>
          {label}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);

export default LayoutField;
